// app/customs/binaryviewer/index.tsx
'use client';

import React, { useEffect, useMemo, useState } from "react";
import * as Global from "@utils/global";
import { BinaryType } from "@utils/global";
import MyModal from '@/customs/mymodal';
import VideoPlayer from '@/customs/videoplayer';
import "./index.css";

interface BinaryViewerProps {
  user_domain: string;
  bin_guid: string | null;
  binaryType?: BinaryType;
}

interface BinaryMeta {
  ok: boolean;
  mime: string | null;
  original_name: string | null;
  has_thumbnail: boolean;
}

const BinaryViewer: React.FC<BinaryViewerProps> = ({
  user_domain,
  bin_guid,
  binaryType = BinaryType.LOW,
}) => {
  const [meta, setMeta] = useState<BinaryMeta | null>(null);
  // const [open, setOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [videoOpen, setVideoOpen] = useState(false);
  const [pdfOpen, setPdfOpen] = useState(false);
  const [emlOpen, setEmlOpen] = useState(false);
  // const [binOpen, setBinOpen] = useState(false);

  // サイズ定義
  const canvasSize =
    binaryType === BinaryType.LOW ? "64px" :
    binaryType === BinaryType.MID ? "120px" : "240px";

  // 用途別URL設定
  const thumbUrl =
    `${Global.getApiBaseUrl()}/spread/get_binary_thumbnail` +
    `?user_domain=${user_domain}&bin_guid=${bin_guid}`;
  const metaUrl =
    `${Global.getApiBaseUrl()}/spread/get_binary_meta` +
    `?user_domain=${user_domain}&bin_guid=${bin_guid}`;
  const binaryViewUrl =
    `${Global.getApiBaseUrl()}/spread/get_binary_view` +
    `?user_domain=${user_domain}&bin_guid=${bin_guid}`;
  const binaryDownloadUrl =
    `${Global.getApiBaseUrl()}/spread/get_binary_download` +
    `?user_domain=${user_domain}&bin_guid=${bin_guid}`;
  const emlToHtmlUrl =
    `${Global.getApiBaseUrl()}/spread/get_eml_to_html` +
    `?user_domain=${user_domain}&bin_guid=${bin_guid}`;

  useEffect(() => {
    if (!bin_guid) return;
    fetch(metaUrl)
      .then(r => r.json())
      .then(setMeta)
      .catch(err => console.error("meta fetch error:", err));
  }, [bin_guid, metaUrl]);

  if (!bin_guid) return null;

  const isImage = meta?.mime?.startsWith("image/");
  const isVideo = meta?.mime?.startsWith("video/");
  const isPdf = meta?.mime === "application/pdf";
  const isEml = meta?.mime === "message/rfc822";

  return (
    <>
      {/* <div className="binary-thumb-container">
        <button
          type="button"
          className="binary-thumb-button"
          onClick={(e) => {
            e.stopPropagation();
            if (isImage) setImageOpen(true);
            else if (isVideo) setVideoOpen(true);
            else if (isPdf) setPdfOpen(true);
            else if (isEml) setEmlOpen(true);
            else window.location.href = binaryViewUrl;
          }}
        >
          <img src={thumbUrl} className="binary-thumb-img" style={{ width: canvasSize, height: canvasSize,}} />
          {(isImage || isVideo || isPdf || isEml) && (
            <i className="preview-icon">
              <i className="fas fa-plus"></i>
            </i>
          )}        
        </button>
      </div> */}
      <div className="binary-thumb-container">
        <div className="thumb-wrapper" style={{ width: canvasSize, height: canvasSize }}>
          {/* 画像クリックはリンク */}
          <a
            href={binaryViewUrl}
            target="_blank"
            onClick={(e) => {
              // 親の row click を止めたいなら
              e.stopPropagation();
            }}
          >
            <img
              src={thumbUrl}
              className="binary-thumb-img"
              style={{ width: canvasSize, height: canvasSize }}
            />
          </a>

          {/* ＋アイコンは onClick プレビュー */}
          {(isImage || isVideo || isPdf || isEml) && (
            <i
              className="preview-icon"
              onClick={(e) => {
                e.stopPropagation();
                if (isImage) setImageOpen(true);
                else if (isVideo) setVideoOpen(true);
                else if (isPdf) setPdfOpen(true);
                else if (isEml) setEmlOpen(true);
                else window.location.href = binaryViewUrl;
              }}
            >
              <i className="fas fa-search"></i>
            </i>
          )}
        </div>
      </div>




      {isImage && imageOpen && (
        <MyModal onClose={() => setImageOpen(false)}>
          <div className="modal-header">
            <i className="far fa-image"></i>
            <span>{meta?.original_name}</span>
          </div>

          <div
            className="modal-body"
            style={{
              width: "80vw",
              height: "80vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "#111",
            }}
          >
            <img
              src={binaryViewUrl}
              alt={meta?.original_name ?? ""}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          </div>

          <div className="modal-footer">
            <a
              href={binaryDownloadUrl}
              download={meta?.original_name ?? undefined}
            >
              ダウンロード
            </a>
          </div>
        </MyModal>
      )}

      {isVideo && videoOpen && (
        <MyModal onClose={() => setVideoOpen(false)}>
          <div className="modal-header">
            <i className="fas fa-photo-video"></i>
            <span>{meta?.original_name}</span>
          </div>
          <div className="modal-body">
            <VideoPlayer
              src={binaryViewUrl}
              title={meta?.original_name ?? ""}
            />
          </div>
          <div className="modal-footer">
            <a
              href={binaryDownloadUrl}
              download={meta?.original_name ?? undefined}
            >
              ダウンロード
            </a>
          </div>
        </MyModal>
      )}

      {isPdf && pdfOpen && (
        <MyModal onClose={() => setPdfOpen(false)}>
          <div className="modal-header">
            <i className="far fa-file-pdf" />
            <span>{meta?.original_name}</span>
          </div>
          <div style={{ width: "80vw", height: "80vh" }}>
            <iframe
              className="modal-body"
              src={binaryViewUrl}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </div>
          <div className="modal-footer">
            <a
              href={binaryDownloadUrl}
              download={meta?.original_name ?? undefined}
            >
              ダウンロード
            </a>
          </div>
        </MyModal>
      )}

      {isEml && emlOpen && (
        <MyModal onClose={() => setEmlOpen(false)}>
          <div className="modal-header">
            <i className="fas fa-envelope"></i>
            <span>{meta?.original_name}</span>
          </div>
          <div className="modal-body" style={{ width: "80vw", height: "80vh" }}>
            <iframe
              src={emlToHtmlUrl}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </div>
          <div className="modal-footer">
            <a
              href={binaryDownloadUrl}
              download={meta?.original_name ?? undefined}
            >
              ダウンロード
            </a>
          </div>
        </MyModal>
      )}
    </>
  );
};

export default BinaryViewer;
